import { ChangeDetectorRef, Component, inject, OnInit } from "@angular/core";
import { InstanceService, UserService } from "#services/api";
import { AsyncCommunicationService } from "#services/shared";
import { Subscription } from "rxjs";
import OktaAuth from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  public isAdminMenuVisible: boolean;
  public displaySyncModal: boolean = false;
  public isInstancesMaintenanceVisible: boolean;
  public isMasterDataSyncVisible: boolean;
  public isAdmin: boolean;
  public projectActions: boolean = false;
  public selectedProject: string = '';
  private projectSubscription: Subscription;
  private readonly _oktaAuth: OktaAuth = inject(OKTA_AUTH);
  private fullNamePollingInterval: any;
  // Removed duplicate property declarations

  public get isFromTapro(): boolean {
    return this.userSvc.isFromTapro();
  }

  constructor(
  private userSvc: UserService,
  private instanceSvc: InstanceService,
    private asyncService: AsyncCommunicationService,
    private readonly _msalService: MsalService,
    private cdRef: ChangeDetectorRef
  ) {
    this.projectSubscription = this.asyncService
      .getProject()
      .subscribe((project) => {
        if (project) {
          this.selectedProject = project;
        }
      });
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  ngOnInit() {
    if (this.fullNamePollingInterval) {
      clearInterval(this.fullNamePollingInterval);
    }
    if (sessionStorage.getItem("FullName")) {
      this.initHeaderState();
    } else {
      // Poll for FullName every 200ms until it appears, then initialize header
      this.fullNamePollingInterval = setInterval(() => {
        if (sessionStorage.getItem("FullName")) {
          clearInterval(this.fullNamePollingInterval);
          this.initHeaderState();
        }
      }, 200);
    }
    // Listen for authentication completion and then call initHeaderState()
    window.addEventListener("storage", (event) => {
      if (event.key === "FullName" && event.newValue) {
        this.initHeaderState();
      }
    });
  }

  private initHeaderState() {
    const isAdmin = this.userSvc.isSystemAdmin();
    const isScheduler = this.userSvc.isScheduler();
    this.instanceSvc.getInstancesMulticast().subscribe((v) => {
      this.isMasterDataSyncVisible =
        !isAdmin && isScheduler && v.length === 1;
      this.isInstancesMaintenanceVisible =
        (isScheduler && v.length > 1) || isAdmin;
      this.cdRef.detectChanges();
    });
    this.isAdminMenuVisible = isAdmin || isScheduler;
    this.isAdmin = isAdmin;
  }

  hoverProjectLevel() {
  this.projectActions = true; // Set projectActions to true
  }

  mouseOut() {
  this.projectActions = false; // Set projectActions to false
  }

  async logout() {
    if (sessionStorage.getItem("UserType") === "nonchevron") {
      await this._oktaAuth.signOut();
      sessionStorage.clear();
      localStorage.clear();
      return;
    } else if (sessionStorage.getItem("UserType") === "chevron") {
      this._msalService.logout();
      sessionStorage.clear();
      localStorage.clear();
      return;
    }
  }
}
